import { useMutation, useQueryClient } from '@tanstack/react-query'
import { JsonRpcError } from '~/types'
import { WithdrawRequest, WithdrawRequestListResponse } from '../types'
import { keepStaffContext } from './keepStaffContext'

export const useWithdrawDecline = () => {
    const queryClient = useQueryClient()

    return useMutation<WithdrawRequest, JsonRpcError, unknown>({
        mutationFn: async ({ uuid, comment }) => {
            const resp = await fetch('/rpc', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    jsonrpc: '2.0',
                    id: 1,
                    method: 'bank.withdraw_request.decline',
                    params: {
                        uuid,
                        comment,
                    },
                }),
            })
            const data = await resp.json()

            if (data.error) {
                throw data
            } else {
                return data.result
            }
        },
        onSuccess: (data) => {
            queryClient.setQueriesData(['withdraw_requests'], (prev: WithdrawRequestListResponse) => {
                return {
                    ...prev,
                    data: prev.data?.map((item) => {
                        if (item.uuid === data.uuid) {
                            return keepStaffContext(item, data)
                        } else if (data.also_declined?.includes(item.uuid)) {
                            // Declined by the cascade. Marked here so the row
                            // stops offering Approve and Decline the moment the
                            // toast says it was declined; the refetch below
                            // then brings its real state.
                            return { ...item, status: 'declined' }
                        } else {
                            return item
                        }
                    }),
                }
            })
            if (data.also_declined?.length) queryClient.invalidateQueries(['withdraw_requests'])
            queryClient.invalidateQueries(['withdraw_request.summary'])
            // The verdict and block pills are cached for good (`staleTime:
            // Infinity`); an action is exactly when they may have moved.
            queryClient.invalidateQueries(['withdraw_verdicts'])
            queryClient.invalidateQueries(['payout_wallet_balance'])
        },
        retry: false,
    })
}
